import { render, staticRenderFns } from "./goal-survey-statistics-item.vue?vue&type=template&id=42b4c7b6&"
import script from "./goal-survey-statistics-item.vue?vue&type=script&lang=ts&"
export * from "./goal-survey-statistics-item.vue?vue&type=script&lang=ts&"
import style0 from "./goal-survey-statistics-item.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports